import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Wrapper = styled.div`
    width: 100%;
    color: ${COLORS.TextWhite};

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-bottom: -30px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin-bottom: -64px;
        margin-top: 64px;
    }
`;

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    position: relative;

    @media (max-width: ${wideBreakpoints.laptop}) {
        justify-content: space-around;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column;
    }
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    justify-items: center;
    max-width: 532px;
    margin-right: 200px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        margin-right: 80px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        max-width: auto;
        margin-right: 5px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        max-width: 430px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-right: 0;
        max-width: auto;
        order: 2;
    }
`;

export const SubTitle = styled.div`
    ${FONTS.H4};
    color: ${COLORS.TextWhite};
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 10px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.H5};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        font-size: 12px;
        line-height: 24px;
    }
`;

export const Title = styled.h1`
    ${FONTS.H1};
    font-size: 40px;
    line-height: 56px;
    margin-bottom: 30px;
    margin-top: 0;

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.H2};
    };

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H3};
    };
`;

export const ItemsBlock = styled.div`
    display: block;
    align-items: center;
`;

export const Item = styled.div`
    display: flex;
    margin-bottom: 12px;
    flex-wrap: nowrap;
    align-items: flex-start;
`;

export const IconBlock = styled.div`
    width: 30px;
    justify-content: center;
    padding-right: 20px;
    height: 24px;
`;

export const Text = styled.span`
    ${FONTS.S};

    b {
        ${FONTS.H5}
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.XS};

        b {
            ${FONTS.H6}
        }
    };

`;

export const Button = styled(BaseButton)`
    width: 226px;
    height: 48px;
    margin-top: 30px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin: 16px auto 0 auto;
        width: 100%;
    };
`;

export const Picture = styled.picture`
    transition: all ease-in .3s;
    display: flex;
    opacity: 0;
    position: absolute;

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: 270px;
        height: auto;
        bottom: 33%;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        right: 3em;
        bottom: 57%;;
    }

    @media (max-width: 550px) {
        right: 10%;
        bottom: 70%;
    }
`;

export const ImageContainer = styled.div`
    height: 490px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        height: 275px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        order: 1;
    }
`;

export const ImgStyled = styled(LazyLoadImage)`
    height: 480px;
    width: auto;
    object-fit: contain;

    @media (max-width: ${wideBreakpoints.laptop}) {
        height: 400px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        height: 245px;
    }
`;
